/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiBase from '@goldwasserexchange/oui';
import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { Trans } from '@lingui/macro';
import { Check } from 'react-feather';
import { UnorderedListWithBarAndIcon } from '../../../../OUI-dom/List';
import ipadOnlineCashflow from './ipadOnlineCashflow.png';

const onlinePresentationTitle = (
  <Trans>
    Suivez l'évolution de votre compte en ligne
  </Trans>
);

const onlinePresentationIntro = (
  <Trans>
    <ouiDom.TextSnippet.TextSnippet
      fontSize="s"
      fontWeight={ouiStyle.Constants.FontWeightProp.bold}
      color={ouiStyle.Constants.Colors.accent}
    >
      Entièrement sécurisé,&#32;
    </ouiDom.TextSnippet.TextSnippet>
    ce service vous permet de consulter à tout moment et n'importe où dans le monde, l'état de vos actifs financiers détenus chez nous.
  </Trans>
);

const onlinePresentationImageStyle: ouiStyle.InStyle = {
};

const onlinePresentationImageCss = ouiStyle.makeCss(onlinePresentationImageStyle);

const onlinePresentationImage = () => (
  <img
    src={ipadOnlineCashflow}
    css={onlinePresentationImageCss}
    alt="illustration du compte goldwasser online"
  />
);

export const OnlinePresentationSection = () => (
  <ouiDom.HeadingSection.HeadingSection
    index={5}
    name="OnlinePresentation"
    paddingTop="double"
    paddingBottom="double"
    paddingHorizontal="simple"
    container={ouiStyle.Constants.Container.full}
    innerContainer={ouiStyle.Constants.Container.xl}
    innerFlexDirection={[ouiStyle.Constants.InFlexDirectionProp.col, undefined, undefined, ouiStyle.Constants.InFlexDirectionProp.row, undefined, undefined]}
    mainDisplay={ouiStyle.Constants.DisplayProp.flex}
    mainFlexDirection={ouiStyle.Constants.InFlexDirectionProp.col}
    mainJustifyContent={ouiStyle.Constants.JustifyContentProp.center}
    mainContainer={ouiStyle.Constants.Container.column}
    mainMarginLeft="none"
    mainMarginRight="none"
    mainPaddingHorizontal="simple"
    mainPaddingVertical="double"
    illustrationPosition="left"
    backgroundImage={`linear-gradient(180deg, ${ouiStyle.Constants.Colors.fadeGradient}, ${ouiStyle.Constants.Colors.primaryLigther})`}
  >
    <TopModel
      name="HeadingSectionTitleContainer-OnlinePresentation"
      fontSize="xs"
    >
      {ouiDom.HeadingSection.DomH2}
    </TopModel>
    <TopModel name="HeadingSectionTitleContent-OnlinePresentation">
      {onlinePresentationTitle}
    </TopModel>
    <TopModel<ouiBase.P.PProps>
      name="HeadingSectionIntroContainer-OnlinePresentation"
      fontSize="s"
      color={ouiStyle.Constants.Colors.accent}
    >
      {ouiDom.P.DomPContainer}
    </TopModel>
    <TopModel name="HeadingSectionIntroContent-OnlinePresentation">
      {onlinePresentationIntro}
    </TopModel>
    <TopModel
      name="HeadingSectionIllustrationContainer-OnlinePresentation"
      padding="double"
      widthLines={['full', undefined, undefined, '1/2', undefined, undefined]}
      display={ouiStyle.Constants.DisplayProp.flex}
      justifyContent={ouiStyle.Constants.JustifyContentProp.center}
    >
      {ouiDom.HeadingSection.DomIllustrationContainer}
    </TopModel>
    <TopModel name="HeadingSectionIllustrationContent-OnlinePresentation">
      {onlinePresentationImage}
    </TopModel>
    <UnorderedListWithBarAndIcon
      list={[
        '0-OnlinePresentation',
        '1-OnlinePresentation',
        '2-OnlinePresentation',
        '3-OnlinePresentation',
      ]}
      color={ouiStyle.Constants.Colors.primary}
      fontSize="m"
      paddingVertical="simple"
      barColor={ouiStyle.Constants.Colors.inverted}
      barWidthLines="full"

    >
      <TopModel
        name="ListElementIconContent"
        color={ouiStyle.Constants.Colors.accent}
        size={28}
        strokeWidth="3"
      >
        {(props) => <Check {...props} />}
      </TopModel>
      <TopModel name="ListElementContent-primaryKey-0-OnlinePresentation">
        <Trans>
          <ouiDom.TextSnippet.TextSnippet
            fontSize="m"
            color={ouiStyle.Constants.Colors.primary}
            fontWeight={ouiStyle.Constants.FontWeightProp.bold}
          >
            Mesurer&#32;
          </ouiDom.TextSnippet.TextSnippet>
          votre performance
        </Trans>
      </TopModel>
      <TopModel name="ListElementContent-primaryKey-1-OnlinePresentation">
        <Trans>
          <ouiDom.TextSnippet.TextSnippet
            fontSize="m"
            color={ouiStyle.Constants.Colors.primary}
            fontWeight={ouiStyle.Constants.FontWeightProp.bold}
          >
            Suivre&#32;
          </ouiDom.TextSnippet.TextSnippet>
          l'ensemble de vos comptes
        </Trans>
      </TopModel>
      <TopModel name="ListElementContent-primaryKey-2-OnlinePresentation">
        <Trans>
          <ouiDom.TextSnippet.TextSnippet
            fontSize="m"
            color={ouiStyle.Constants.Colors.primary}
            fontWeight={ouiStyle.Constants.FontWeightProp.bold}
          >
            Initier&#32;
          </ouiDom.TextSnippet.TextSnippet>
          des transferts
        </Trans>
      </TopModel>
      <TopModel name="ListElementContent-primaryKey-3-OnlinePresentation">
        <Trans>
          <ouiDom.TextSnippet.TextSnippet
            fontSize="m"
            color={ouiStyle.Constants.Colors.primary}
            fontWeight={ouiStyle.Constants.FontWeightProp.bold}
          >
            Planifier&#32;
          </ouiDom.TextSnippet.TextSnippet>
          votre budget
        </Trans>
      </TopModel>
    </UnorderedListWithBarAndIcon>
  </ouiDom.HeadingSection.HeadingSection>
);
